import { IState } from '@/store/auth/interfaces'

export default (): IState => ({
  user: null,
})
